// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay__overlay___3lwSZ","invisible":"overlay__invisible___3QM3V","backdrop":"overlay__backdrop___1MJX5","active":"overlay__active___1raBh","fadeUp":"overlay__fadeUp___3USqj","lateFadeUp":"overlay__lateFadeUp___1QLOu","lateFadeIn":"overlay__lateFadeIn___5a1G_"};


//////////////////
// WEBPACK FOOTER
// ./client/styles/react-toolbox/overlay.scss
// module id = 964
// module chunks = 0